import { use } from 'react';

import { ApplicationContextObj } from '../context';
import { type ApplicationContext } from '../types';

export const useApplication = (): ApplicationContext => {
  const context = use(ApplicationContextObj);

  if (context === undefined) {
    throw new Error(
      "The 'useApplication' hook can only be used inside of the ApplicationProvider!",
    );
  }
  return context;
};
